import camelize from 'camelcase-keys-deep';

export default class Hearing {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  document() {
    return this.env().Document.getById(this.documentId);
  }

  discrepancy() {
    return this.document().discrepancy();
  }
}
